import { GUIA_LABELS } from '@utils/guiaLabels.js'
import type { PassoJornada } from '@content/jornada.js'

export type PassoBadgeKind = 'ferramenta' | 'checklist' | 'referencia' | 'critico' | 'camada'

export interface PassoBadge {
  kind: PassoBadgeKind
  label: string
}

export function getPassoBadges(passo: PassoJornada): PassoBadge[] {
  const badges: PassoBadge[] = []
  if (passo.temFerramenta) badges.push({ kind: 'ferramenta', label: GUIA_LABELS.recursoBadge })
  if (passo.temChecklist) badges.push({ kind: 'checklist', label: 'Checklist' })
  if (passo.critico) badges.push({ kind: 'critico', label: 'Importante' })
  return badges
}
